/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';
import RegionSettingsDetails from './RegionSettingDetails';

const RegionSettingsWithStore = () => {
    const { generalSettingsStore, userStore, regionStore } = getStore();
    const { selectedRegionId } = regionStore;
    const {
        isSettingsDisabled,
        regionName,
        regionNameError,
        regionDescription,
        regionExtraVoteLabel,
        regionExtraVoteQuantity,
        regionExtraVoteQuantityError,
        regionNoVoteDescription,
        selectedRegionData,
        handleChangeRegionAttribute,
        setRegionData,
        setRegionName,
        setRegionDescription,
        setRegionExtraVoteLabel,
        setRegionExtraVoteQuantity,
        setRegionNoVoteDescription,
        setRegionNameError,
        setRegionExtraVoteQuantityError,
        updateRegionSettingsData,
    } = generalSettingsStore;

    const isSuperAdmin = Boolean(userStore.isInitialized && userStore.getIsSuperAdmin());

    useEffect(() => {
        setRegionData();
    }, [selectedRegionData, selectedRegionId]);

    return (
        <RegionSettingsDetails
            isSettingsDisabled={isSettingsDisabled}
            isSuperAdmin={isSuperAdmin}
            regionName={regionName}
            regionNameError={regionNameError}
            regionDescription={regionDescription}
            regionExtraVoteLabel={regionExtraVoteLabel}
            regionExtraVoteQuantity={regionExtraVoteQuantity}
            regionExtraVoteQuantityError={regionExtraVoteQuantityError}
            regionNoVoteDescription={regionNoVoteDescription}
            selectedRegionData={selectedRegionData}
            handleChangeRegionAttribute={handleChangeRegionAttribute}
            setRegionName={setRegionName}
            setRegionDescription={setRegionDescription}
            setRegionExtraVoteLabel={setRegionExtraVoteLabel}
            setRegionExtraVoteQuantity={setRegionExtraVoteQuantity}
            setRegionNoVoteDescription={setRegionNoVoteDescription}
            setRegionNameError={setRegionNameError}
            setRegionExtraVoteQuantityError={setRegionExtraVoteQuantityError}
            updateRegionSettingsData={updateRegionSettingsData}
        />
    );
};

export default observer(RegionSettingsWithStore);
